<template>
  <div class="order-list-container">
    <div class="goods-table">
      <div class="goods-thead">
        <div class="col col2">商品信息</div>
        <div class="col col4">单价</div>
        <div class="col col4">数量</div>
        <div class="col col4">实付款</div>
        <div class="col col6">操作</div>
      </div>
      <div class="goods-tbody">
        <div v-for="(order, indexO) in orderInfo.orders" :key="indexO" class="order-item">
          <div class="order-header">
            订单时间：{{order.createTime}} 订单编号 {{order.orderId}}
          </div>
          <div class="order-content">
            <div class="col col2 goods-title-pic">
              <a :href="'/page.html#/pages/plateform/productDetail?productId=' + order.productId">
                <img :src="order.coverPhoto" width="60" height="60">
              </a>
              <div class="goods-describ elli">
                <p>
                  <a :href="'/page.html#/pages/plateform/productDetail?productId=' + order.productId">{{order.prodName}}</a>
                </p>
              </div>
            </div>
            <div class="col col4 goods-price">￥{{order.price}}</div>
            <div class="col col4 good-num">{{order.cartNum}}</div>
            <div class="col col4 orange-bold xiaoji">￥{{order.cartNum * order.price}}</div>
            <div class="col col6 order-actions">
              <template v-if="order.state == 3104">
                <el-button size="small" @click="closeOrder(order)">关闭订单</el-button>
              </template>
              <template v-if="order.state == 2002">
                <div class="status-text">待发货</div>
                <el-button size="small" @click="expeditingDelivery(order)">催发货</el-button>
              </template>
              <template v-if="order.state == 3003">
                <el-button size="small" @click="showLogistic(order)">物流信息</el-button>
                <el-button size="small" @click="showConfirm(order)">确认收货</el-button>
              </template>
              <template v-if="order.state == 4004">
                <el-button size="small" @click="showEvaluate(order)">立即评价</el-button>
                <el-button size="small" @click="showReturn(order)">退货</el-button>
                <el-button size="small" @click="showLogistic(order)">物流信息</el-button>
              </template>
              <template v-if="order.state == 5005">
                <div class="status-text">申请退款</div>
              </template>
              <template v-if="order.state == 7017">
                <div class="status-text">订单已关闭</div>
              </template>
              <template v-if="order.state == 8008">
                <div class="status-text">已完成</div>
              </template>
            </div>
          </div>
          <div class="order-footer">
            订单总价：{{order.totalPrice}}&nbsp;&nbsp;
            收货人姓名：{{order.personName}}&nbsp;&nbsp;
            收货地址电话：{{order.address}}；{{order.tel}}
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      @current-change="handlePageChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next">
    </el-pagination>
  </div>
</template>

<script>
import { getOrderList, expeditingDelivery, closeOrder } from '@/api/platform/personalCenter/orderApi'

export default {
  name: 'OrderList',
  data() {
    return {
      orderInfo: {
        orders: [],
        total: 0,
        records: 1
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        const params = {
          page: this.currentPage,
          row: this.pageSize,
          states: '2002,2012,2013,3003,4004,5005,6006,7007,8008,9009,2102,3103,3104,3004'
        }
        const res = await getOrderList(params)
        this.orderInfo.orders = res.data
        this.total = res.total
        console.log(this.orderInfo.records)
      } catch (error) {
        console.error('获取订单列表失败:', error)
      }
    },
    handlePageChange(page) {
      this.currentPage = page
      this.getList()
    },
    async expeditingDelivery(order) {
      try {
        await expeditingDelivery({
          orderId: order.orderId,
          cartId: order.cartId,
          personId: order.personId,
          eventMsg: '用户催发货',
          shopId: order.shopId
        })
        this.$message.success('已催商家发货')
      } catch (error) {
        this.$message.error(error.message || '操作失败')
      }
    },
    async closeOrder(order) {
      try {
        await closeOrder(order)
        this.$message.success('订单已关闭')
        this.getList()
      } catch (error) {
        this.$message.error(error.message || '操作失败')
      }
    },
    showConfirm(order) {
      this.$parent.$refs.confirmOrderDialog.open(order)
    },
    showEvaluate(order) {
      this.$parent.$refs.evaluateDialog.open(order)
    },
    showLogistic(order) {
      this.$parent.$refs.logisticDialog.open(order)
    },
    showReturn(order) {
      this.$parent.$refs.returnDialog.open(order)
    }
  }
}
</script>

<style scoped>
.order-list-container {
  width: 100%;
}

.goods-table {
  width: 100%;
  border: 1px solid #e4e4e4;
}

.goods-thead {
  display: flex;
  padding: 10px 0;
  background: #f5f5f5;
  border-bottom: 1px solid #e4e4e4;
}

.goods-thead .col {
  padding: 0 10px;
}

.col2 { flex: 2; }
.col4 { flex: 1; }
.col6 { flex: 1.5; }

.order-item {
  border-bottom: 1px solid #e4e4e4;
}

.order-header, .order-footer {
  padding: 10px 20px;
  color: #666;
}

.order-content {
  display: flex;
  padding: 10px 0;
}

.goods-title-pic {
  display: flex;
  align-items: center;
}

.goods-title-pic img {
  margin-right: 10px;
}

.goods-describ {
  flex: 1;
}

.orange-bold {
  color: #ff6700;
  font-weight: bold;
}

.order-actions {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.status-text {
  padding: 5px 0;
}
</style>